/*
 * View for the dialog window
 */

define(["marionette", "underscore", "./template/dialogWindowTemplate.html"], function (
  Marionette,
  _,
  DialogWindowTemplate,
) {
  "use strict";

  const DialogWindowView = {};

  DialogWindowView.dialogWindowView = Marionette.ItemView.extend({
    template: DialogWindowTemplate,

    textboxes: function () {
      const showComment = this.model.get("showComment");
      let commentConfig = {
        enableSelector: "#comment",
        modelAttribute: "comment",
        placeholder: "task.comment",
        textArea: true,
      };
      if (typeof showComment == "string") {
        commentConfig.placeholder = showComment;
      } else if (typeof showComment == "object") {
        commentConfig = _.assign(commentConfig, showComment);
      }
      return {
        "#comment": commentConfig,
      };
    },
    triggers: {
      "click #yesButton": "click:yes",
      "click #noButton": "click:no",
      "click #cancelButton": "click:cancel",
      "click #okButton": "click:ok",
      "click #confirmButton": "click:confirm",
    },
  });

  return DialogWindowView;
});
